import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';

import { InAndOut, InAndOutService } from '../../services/in-and-out.service';

import { Observable } from 'rxjs/Observable';
import { Subscription } from 'rxjs/Subscription';

@Component({
  selector: 'app-update-in-and-out',
  templateUrl: './update-in-and-out.component.html',
  styleUrls: ['./update-in-and-out.component.css']
})
export class UpdateInAndOutComponent implements OnInit {

  inAndOutForm: FormGroup;

  tipos=[
    {name:'Elija un tipo...',value:''},
    {name:'Entrada',value:'in'},
    {name:'Salida',value:'out'}
  ];

  sid: string;
  inAndOut: any;
  subsciptionInAndOut: Subscription;

  constructor(
    private inAndOutService: InAndOutService,
    private fb: FormBuilder,
    private activatedRoute: ActivatedRoute
  ) {
    this.sid = this.activatedRoute.snapshot.paramMap.get('id');
  }

  ngOnInit() {
    this.createForm();
    this.subsciptionInAndOut = this.inAndOutService.getInAndOut(this.sid).subscribe(data => {
      this.inAndOut = data;
      this.inAndOutForm.get('type').setValue(data.type);
      this.inAndOutForm.get('description').setValue(data.description);

      this.subsciptionInAndOut.unsubscribe();
    });
  }

  ngOnDestroy() {
  }

  createForm() {
    this.inAndOutForm = this.fb.group({
      type: ['', Validators.required],
      description: ['', Validators.required]
    });
  }

  onSubmit({ value, valid }: { value: any, valid: boolean }) {
    this.inAndOutService.updateInAndOut(this.sid, value);
  }

}
